
const validateClaim = (values) => {
  const errors = {};

  if (!values.insuranceCompanyId) {
    if (!Number.isInteger(values.insuranceCompanyId)) {
      errors.insuranceCompanyId = 'Please select an option';
    }
  }

  if (!values.claimForm) {
    if (!Number.isInteger(values.claimForm)) {
      errors.claimForm = 'Please select an option';
    }
  }

  if (!values.claimFormPrintFormat) {
    if (!Number.isInteger(values.claimFormPrintFormat)) {
      errors.claimFormPrintFormat = 'Please select an option';
    }
  }
  if (!values.PayerControlReferenceNumber) {
    errors.PayerControlReferenceNumber = 'Please enter control reference number.';
  }

  return errors;
};


export default validateClaim;



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/ValidateSubmitClaim.js